"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeMapping = void 0;
exports.formatValueWithUnit = formatValueWithUnit;
var translation_1 = __importDefault(require("@src/services/translation"));
exports.timeMapping = {
    'Alle 1 Years': translation_1.default.t('yearly'),
    '1 YEARS': translation_1.default.t('yearly'),
    '1 YEAR': translation_1.default.t('yearly'),
    'Alle 12 Monate': translation_1.default.t('yearly'),
    '12 MONTHS': translation_1.default.t('yearly'),
    '12 MONTH': translation_1.default.t('yearly'),
    '1 MONTHS': translation_1.default.t('monthly'),
    '1 MONTH': translation_1.default.t('monthly'),
    'Alle 1 Monate': translation_1.default.t('monthly'),
    'Alle 6 Monate': translation_1.default.t('semi-annually'),
    '6 MONTHS': translation_1.default.t('semi-annually'),
    '6 MONTH': translation_1.default.t('semi-annually'),
    '1 WEEKS': translation_1.default.t('weekly'),
    '1 WEEK': translation_1.default.t('weekly'),
    'Alle 1 Wochen': translation_1.default.t('weekly'),
    '1 DAYS': translation_1.default.t('daily'),
    '1 DAY': translation_1.default.t('daily'),
    'Alle 1 Tage': translation_1.default.t('daily'),
};
/**
 * Takes a value (number) and a unit (DAY/WEEK/MONTH/YEAR) checks for known conversions (like monthly) and translates it
 * @param value
 * @param unit
 * @param isFrequency if the unit should be converted to a frequency e.g. yearly instead of "1 YEAR"
 * @returns
 */
function formatValueWithUnit(value, unit, isFrequency) {
    if (isFrequency === void 0) { isFrequency = true; }
    if (!value || !unit) {
        console.warn('Tried formatting undefined unit for price preview');
        return '';
    }
    var val = value + ' ' + unit;
    //console.log("checking time mapping for '" + val + "' with mapping", this.timeMapping, this.timeMapping[val]);
    if (exports.timeMapping[val] && isFrequency) {
        //console.log('using mapped interval', this.timeMapping[val]);
        return exports.timeMapping[val];
    }
    else {
        //console.log('using unmapped interval', val);
        return value + ' ' + translation_1.default.t(value > 1 ? unit + 'S' : unit);
    }
}
